import {
  Badge,
  Button,
  Card,
  Icon,
  Input,
  notification,
  Switch,
  Table,
  Tooltip
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Countries, ProcessList } from '../../../components/_utils/appUtils'
import { allUserExportFxn, getAllUsersFxn } from '../actions'
import Request from '../../../request'
import EditAuthors from '../editAuthors'
import EditUser from '../drawers/editUser'
import ChangePasswordDrawer from '../drawers/changePassword'
import { apiUrl } from '../../../settings'
import MemberHistory from '../../article/reviewer/memberHistory'
import AuthorHistory from '../../article/drawers/authorHistory'

const regExpFilters = [
  'name',
  'local.email',
  'address',
  'instituteName',
  'mobileNo',
  'userName',
  'displayPassword',
  'postalCode',
  'department',
  'lastName'
]

class allAuthors extends Component {
  state = {
    authorData: [],
    userId: '',
    visible: false,
    userType: ''
  }
  events = {
    showEdit: (data) => {
      this.setState({
        visible: true, userId: data._id,
        userType: data.userType
      })
    },
    hideEdit: () => {
      this.setState({
        visible: false, userId: '', userType: ''
      })
    },
    onSubmit: () => {
      this.setState({
        visible: false, userId: '', userType: ''
      }, () => {
        this.table.current.reload()
      })
    },
    showHistory: (data) => {
      this.setState({
        historyState: {
          visible: true,
          emailId: data.local.email
        }
      })
    },
    hideHistory: () => {
      this.setState({
        historyState: {
          visible: false,
          emailId: '',
          data: {}
        }
      })
    }

  }

  loadAuthors = params => {
    let { dispatch } = this.props
    return new Promise(async resolve => {
      let data = await dispatch(
        getAllUsersFxn({
          ...params, userType: 'Author',
          regExFilters: regExpFilters
        })
      )
      this.setState({
        filteredUsers: data.data
      });
      resolve(data)
    })
  }

  constructor(props) {
    super(props)

    this.table = React.createRef()
    this.state = {
      open: false,
      editVal: {},
      indexVal1: '',
      visible: false,
      userId: '',
      userType: '',
      changePasswordVisible: false,
      changePasswordUserId: '',
      historyState: {
        visible: false,
        emailId: ''
      }
    }
  }

  exportExcel = async () => {
    const { filteredUsers } = this.state;
    let { dispatch } = this.props

    let resp = await dispatch(allUserExportFxn({data:filteredUsers}))
    if (resp && resp.success) {
      window.open(`${apiUrl}${resp.fileName}`, 'Download')
    }
  }

  componentDidMount() {
  }

  showEditAdmin = (val, index) => {
    this.setState({ open: true, editVal: val, indexVal1: index })
  }

  onClose = () => {
    this.setState({
      open: false
    })
  }

  editSuccessfull = () => {
    this.setState({ open: false })
    this.table.current.reload()
  }

  showChangePassword = (record) => {
    this.setState({
      changePasswordVisible: true,
      changePasswordUserId: record._id
    })
  }

  hideChangePassword = () => {
    this.setState({
      changePasswordVisible: false,
      changePasswordUserId: ''
    })
  }

  changePasswordSuccessful = () => {
    this.setState({
      changePasswordVisible: false,
      changePasswordUserId: ''
    })
    this.table.current.reload()
  }

  render() {
    let { state: { visible, userId, userType }, events } = this
    let { currentUser } = this.props

    const columns = [
      {
        title: 'Name',
        key: 'name',
        sorter: true,
        dataIndex: 'name',
        searchTextName: 'name',
        filterByRegex: true,
        fixed: 'left',
        width: 130
      },
      {
        title: 'Last Name',
        key: 'lastName',
        sorter: true,
        dataIndex: 'lastName',
        searchTextName: 'lastName',
        filterByRegex: true,
        fixed: 'left',
        width: 130
      },
      {
        title: 'UserType',
        key: 'userType',
        sorter: true,
        dataIndex: 'userType',
        searchTextName: 'userType',
        width: 120
      },
      {
        title: 'Email',
        dataIndex: 'local.email',
        key: 'local.email',
        searchTextName: 'email',
        filterByRegex: true,
        width: 180
      },
      ...(currentUser && currentUser.isAdmin
        ? [{
          title: 'Password',
          dataIndex: 'displayPassword',
          key: 'displayPassword',
          searchTextName: 'displayPassword',
          filterByRegex: true,
          width: 120
        }]
        : []),
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
        searchTextName: 'address',
        filterByRegex: true,
        width: 170
      },
      {
        title: 'Institute Name',
        dataIndex: 'instituteName',
        key: 'instituteName',
        searchTextName: 'instituteName',
        filterByRegex: true,
        width: 170
      },
      {
        title: 'Job Title/Designation',
        dataIndex: 'designation',
        key: 'designation',
        searchTextName: 'designation',
        filterByRegex: true,
        width: 170
      },
      {
        title: 'Department',
        dataIndex: 'department',
        key: 'department',
        searchTextName: 'department',
        filterByRegex: true,
        width: 150
      },
      {
        title: 'Postal Code',
        dataIndex: 'postalCode',
        key: 'postalCode',
        searchTextName: 'postalCode',
        filterByRegex: true,
        width: 120
      },
      {
        title: 'Country',
        dataIndex: 'country',
        key: 'country',
        filters: Countries.map(x => ({ text: x.name, value: x.name })),
        width: 150,
        render: (item, record) => {
          return (
            <div>
              <p>{item}</p>
              <p>{record.correspondingAuthorAffiliation}</p>
            </div>
          )
        }
      },
      {
        title: 'Action',
        name: 'action',
        key: 'action',
        dataIndex: 'action',
        width: 180,
        render: (item, record, indexValue) => {
          return (
            <>
              {/* <Tooltip title='Edit  Admin-User' style={{ marginRight: '20px' }}>
                  <Button
                      shape='circle'
                      className='roundSmallBtn'
                      onClick={e => {
                        this.showEditAdmin(record, indexValue)
                      }}>
                    Edit
                  </Button>
                </Tooltip>*/}

              <a className={'btn round btn-default btn-sm'} style={{ marginRight: '10px' }} onClick={() => {
                this.showEditAdmin(record, indexValue)
              }}>Edit</a>

              <a className={'btn round btn-default btn-sm'} onClick={() => {
                this.events.showHistory(record)
              }}>View </a>

              <a className={'btn round btn-default btn-sm'} style={{ marginTop: '6px' }} onClick={() => {
                this.showChangePassword(record)
              }}>Change Password</a>

            </>
          )
        }
      }
    ]
    return (
      //   <>dd{/* {authorData&&authorData} */}</>
      <PageHeaderWrapper title={'All Authors'} content={[
        <>
          <Button
            key='1'
            type='primary'
            onClick={() => {
              this.exportExcel()
            }}>
            <Icon type={'file'} />
            Export
          </Button>
        </>
      ]}>
        <Card bordered={true}>
          <TableComp
            ref={this.table}
            extraProps={{ scroll: { x: 1500 } }}
            columns={columns}
            apiRequest={this.loadAuthors}
          />
        </Card>

        {this.state.open ? (
          <EditAuthors
            visible={this.state.open}
            editVal={this.state.editVal}
            indexVal={this.state.indexVal1}
            onClose={this.onClose}
            editSuccessfull={() => {
              this.editSuccessfull()
            }}
          />
        ) : null}

        {this.state.historyState.visible ? (
          <AuthorHistory
            {...this.state.historyState}
            onClose={events.hideHistory}

          />
        ) : null}

        {this.state.changePasswordVisible ? (
          <ChangePasswordDrawer
            visible={this.state.changePasswordVisible}
            userId={this.state.changePasswordUserId}
            onClose={this.hideChangePassword}
            onSubmitSuccess={this.changePasswordSuccessful}
          />
        ) : null}

        
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories,
  currentUser: global.currentUser
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(allAuthors)
